export enum TaskCancellationStatusType {
  Unassigned = 'Unassigned',
  Assigned = "Assigned",
  CourierHeading = "CourierHeading",
  CourierArrived = "CourierArrived",
  CourierDeparted = "CourierDeparted"
}
